/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';

import useLocalStorage from './useLocalStorage';

/**
 * @returns {{isFilterPinned: boolean, setIsFilterPinned: React.Dispatch<React.SetStateAction<boolean>>}}
 */
export const useFilterPinned = () => {
  const { getLocalStorageItem, setLocalStorageItem } = useLocalStorage();
  const [isFilterPinned, setIsFilterPinned] = useState(false);

  useEffect(() => {
    const isFilterPinnedCookie = getLocalStorageItem('isFilterPinned') === 'true';

    setIsFilterPinned(isFilterPinnedCookie);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLocalStorageItem('isFilterPinned', isFilterPinned);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFilterPinned]);

  return { isFilterPinned, setIsFilterPinned };
};
